import type { IconProps } from '../types/IconProps.ts';
export const Lock: IconProps = {
    name: 'Lock',
    children: [
        `<rect width="18" height="11" x="3" y="11" rx="1" />`,
        `<path d="M7 11V7a5 5 0 0 1 10 0v4" />`,
    ]
};